import { render } from "./SzunyoghhaloPage.vue?vue&type=template&id=1b956d2a&scoped=true"
import script from "./SzunyoghhaloPage.vue?vue&type=script&lang=js"
export * from "./SzunyoghhaloPage.vue?vue&type=script&lang=js"

import "./SzunyoghhaloPage.vue?vue&type=style&index=0&id=1b956d2a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b956d2a"]])

export default __exports__